import { RustModule } from "../../utils/rustLoader";
export class Int32Constant {
    constructor(value) {
        this.value = value;
    }
}
export class Int64Constant {
    constructor(value) {
        this.value = value;
    }
}
export class ByteaConstant {
    constructor(value) {
        this.value = value;
    }
}
export function serializeConstant(c) {
    let constant;
    if (c instanceof Int32Constant)
        constant = RustModule.SigmaRust.Constant.from_i32(c.value);
    else if (c instanceof Int64Constant)
        constant = RustModule.SigmaRust.Constant.from_i64(RustModule.SigmaRust.I64.from_str(c.value.toString()));
    else
        constant = RustModule.SigmaRust.Constant.from_byte_array(c.value);
    return constant.encode_to_base16();
}
export function deserializeConstant(r) {
    const constant = RustModule.SigmaRust.Constant.decode_from_base16(r);
    try {
        return new Int32Constant(constant.to_i32());
    }
    catch (e) {
        try {
            return new Int64Constant(BigInt(constant.to_i64().to_str()));
        }
        catch (e) {
            try {
                return new ByteaConstant(constant.to_byte_array());
            }
            catch (e) {
                return undefined;
            }
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZXJnby9lbnRpdGllcy9jb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUMsVUFBVSxFQUFDLE1BQU0sd0JBQXdCLENBQUE7QUFHakQsTUFBTSxPQUFPLGFBQWE7SUFDeEIsWUFBNEIsS0FBYTtRQUFiLFVBQUssR0FBTCxLQUFLLENBQVE7SUFBRyxDQUFDO0NBQzlDO0FBRUQsTUFBTSxPQUFPLGFBQWE7SUFDeEIsWUFBNEIsS0FBYTtRQUFiLFVBQUssR0FBTCxLQUFLLENBQVE7SUFBRyxDQUFDO0NBQzlDO0FBRUQsTUFBTSxPQUFPLGFBQWE7SUFDeEIsWUFBNEIsS0FBaUI7UUFBakIsVUFBSyxHQUFMLEtBQUssQ0FBWTtJQUFHLENBQUM7Q0FDbEQ7QUFJRCxNQUFNLFVBQVUsaUJBQWlCLENBQUMsQ0FBVztJQUMzQyxJQUFJLFFBQXVCLENBQUE7SUFDM0IsSUFBSSxDQUFDLFlBQVksYUFBYTtRQUFFLFFBQVEsR0FBRyxVQUFVLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFBO1NBQ3JGLElBQUksQ0FBQyxZQUFZLGFBQWE7UUFDakMsUUFBUSxHQUFHLFVBQVUsQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxVQUFVLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDLENBQUE7O1FBQ3JHLFFBQVEsR0FBRyxVQUFVLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxlQUFlLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQ3RFLE9BQU8sUUFBUSxDQUFDLGdCQUFnQixFQUFFLENBQUE7QUFDcEMsQ0FBQztBQUVELE1BQU0sVUFBVSxtQkFBbUIsQ0FBQyxDQUFZO0lBQzlDLE1BQU0sUUFBUSxHQUFHLFVBQVUsQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLGtCQUFrQixDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQ3BFLElBQUk7UUFDRixPQUFPLElBQUksYUFBYSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFBO0tBQzVDO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDVixJQUFJO1lBQ0YsT0FBTyxJQUFJLGFBQWEsQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLE1BQU0sRUFBRSxDQUFDLE1BQU0sRUFBRSxDQUFDLENBQUMsQ0FBQTtTQUM3RDtRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1YsSUFBSTtnQkFDRixPQUFPLElBQUksYUFBYSxDQUFDLFFBQVEsQ0FBQyxhQUFhLEVBQUUsQ0FBQyxDQUFBO2FBQ25EO1lBQUMsT0FBTyxDQUFDLEVBQUU7Z0JBQ1YsT0FBTyxTQUFTLENBQUE7YUFDakI7U0FDRjtLQUNGO0FBQ0gsQ0FBQyJ9